module.exports = __webpack_public_path__ + "img/dotdotdot.dd9fe6ab.svg";